import withMetadataArgument from './withMetadataArgument.js'
import { getCountryCallingCode as _getCountryCallingCode } from '../../core/index.js'

export function getCountryCallingCode() {
	return withMetadataArgument(_getCountryCallingCode, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/getCountryCallingCode.js
// module id = 1162
// module chunks = 22